import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import './Backdoor.scss'
import DevDashboard from './DevDashboard'
import DevLogin from './DevLogin'
import Token from '../../Utils/Token'

export default class Backdoor extends Component {
    constructor(props) {
        super(props)

        this.state = {
            verified: true,
            accessKey: ''
        }
    }

    componentDidMount() {
        const token = Token.getDevToken()
        if (!token) {
            this.props.history.push('/backdoor/login')
        }
    }

    render() {
        const { path } = this.props.match

        return (
            <div className={`backdoor`}>

                <Switch>
                    <Route path={`${path}/login`} exact component={DevLogin} />
                    <Route path={`${path}/`} component={DevDashboard} />
                </Switch>

            </div >
        )
    }
}
